import {createContext, useRef} from "react";

interface HistoryRestoreScroll {
	[key: string]: number;
}
interface HistoryRestoreData {
	[key: string]: any;
}

export const Context = createContext<{
	getRestoreData: () => any | null;
	setRestoreData: (data: any) => void;
	setScrollData: () => void;
	getScrollData: () => number;
}>(null);

const ScrollRestoreProvider = ({children}) => {
	const restoreScroll = useRef<HistoryRestoreScroll>({});
	const restoreData = useRef<HistoryRestoreData>({});

	const setScrollData = () => {
		const {current} = restoreScroll;
		restoreScroll.current = Object.assign(current, {[history.state.key]: document.scrollingElement.scrollTop});
	};
	const getScrollData = () => {
		const {current} = restoreScroll;
		return current[history.state.key] || 0;
	};

	const setRestoreData = (data: any) => {
		const {current} = restoreData;
		restoreData.current = Object.assign(current, {[history.state.key]: data});
	};

	const getRestoreData = () => {
		const {current} = restoreData;
		return current[history.state.key];
	};

	return (
		<Context.Provider value={{setRestoreData, getRestoreData, setScrollData, getScrollData}}>
			{children}
		</Context.Provider>
	);
};

export default ScrollRestoreProvider;
